import { TrendingDown, TrendingUp } from "lucide-react";
import { band } from "@/components/ResultScore";
import { useAtsHistory } from "@/lib/atsScores";

export const ScoreHistory = ({ jobId }) => {
  const h = useAtsHistory(jobId);
  if (h.length < 2) return null;
  const runs = h.slice(-8);
  const delta = h[h.length - 1].score - h[0].score;
  const Icon = delta >= 0 ? TrendingUp : TrendingDown;
  return (
    <div className="rounded-xl border border-[#27272A] bg-[#09090B] p-4" data-testid="score-history">
      <div className="mb-3 flex items-center justify-between">
        <span className="text-[11px] font-semibold uppercase tracking-[0.16em] text-zinc-500">Score history · {h.length} runs</span>
        <span className={`flex items-center gap-1 font-mono text-xs ${delta >= 0 ? "text-emerald-400" : "text-red-400"}`} data-testid="score-history-delta">
          <Icon className="h-3.5 w-3.5" />{delta >= 0 ? "+" : ""}{delta} pts since first run
        </span>
      </div>
      <div className="flex h-16 items-end gap-2">
        {runs.map((r, i) => (
          <div key={r.at} className="flex flex-1 flex-col items-center gap-1" title={new Date(r.at).toLocaleString()}>
            <span className="font-mono text-[10px] text-zinc-400">{r.score}</span>
            <div className="w-full rounded-t" style={{ height: `${Math.max(6, r.score * 0.4)}px`, background: band(r.score).c, opacity: i === runs.length - 1 ? 1 : 0.55 }} />
          </div>
        ))}
      </div>
    </div>
  );
};
